import Body from './Body';
import Header from './Header';

const CategoryItem = {
  Header,
  Body,
};

export default CategoryItem;
